import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import useToast from 'helpers/useToast';

const EXTRACTION_COMPLETE = 'EXTRACTION_COMPLETE';

const useExtractionNotifications = (): void => {
  const { setToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    if (!navigator.serviceWorker) return undefined;

    const handler = (event: MessageEvent) => {
      if (event.data?.type !== EXTRACTION_COMPLETE) return;

      const { card, card_pick_id: cardPickId } = event.data;
      const cardTitle = card?.title || 'Your pick';
      const cardImage = card?.detail_image || card?.icon || null;

      setToast({
        isToastOpen: true,
        toastAction: 'Pick ready',
        toastItemName: cardTitle,
        toastItemEnding: 'has finished loading',
        toastImg: cardImage,
        toastHandler: cardPickId ? () => history.push(`/picks/${cardPickId}`) : undefined,
      });
    };

    navigator.serviceWorker.addEventListener('message', handler);
    return () => navigator.serviceWorker.removeEventListener('message', handler);
  }, [setToast, history]);
};

export default useExtractionNotifications;
